import { set_token, set_user_details, set_user_profile, fetch_and_store_user_profile } from '@/router';
import SnackbarMessage from "@/components/SnackbarMessage/SnackbarMessage.vue";

const login_url = process.env.VUE_APP_LOGIN_URL;
const client_app = process.env.VUE_APP_CLIENT_APP || "epfdsd";

function unwrap_response(data) {
  return data?.data && typeof data.data === "object" && !Array.isArray(data.data)
    ? { ...data.data, ...data }
    : (data || {});
}

function get_error_message(data, fallback = "We could not sign you in. Please try again.") {
  const payload = data?.errors || data?.detail || data?.error || data?.message || data;
  if (!payload) return fallback;
  if (typeof payload === "string") return payload;
  if (Array.isArray(payload)) return payload.join(", ");
  if (typeof payload === "object") return Object.values(payload).flat().join(" ") || fallback;
  return fallback;
}

export default {
  name: 'LoginView',
  components: { SnackbarMessage },
  data() {
    return ({ credentials: { email: '', password: '' }, password_input_type: 'password', is_loading: false, error_message: '', success_message: '', login_url });
  },
  methods: {
    toggle_change_password_type() { this.password_input_type = this.password_input_type === 'password' ? 'text' : 'password'; },
    clear_pending_login() {
      ['pending_user_data', 'pending_username', 'pending_challenge_token', 'pending_login_password'].forEach((key) => {
        sessionStorage.removeItem(key);
      });
    },
    set_error_message(message) { this.error_message = message || 'We could not sign you in. Please try again.'; this.success_message = ''; },
    set_success_message(message) { this.success_message = message || ''; this.error_message = ''; },
    async complete_token_login(data) {
      if (!data.token) throw new Error('No authentication token received.');
      const user = data.user || {};
      set_token(data.token);
      set_user_details({ role_type: user.user_role?.role?.name || user.role || null, user_id: user.id, first_name: user.first_name || '', last_name: user.last_name || '' });
      set_user_profile(user);
      await fetch_and_store_user_profile();
      this.clear_pending_login();
      this.set_success_message(data.message || 'Login successful.');
      this.$router.push('/home');
    },
    async handle_login() {
      this.is_loading = true;
      this.error_message = '';
      this.success_message = '';
      try {
        if (!this.credentials.email || !this.credentials.password) throw new Error('Please enter both your email and password.');
        if (!login_url) throw new Error('Login endpoint is not configured.');
        const response = await fetch(login_url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ username: this.credentials.email, password: this.credentials.password, client_app }) });
        const raw = await response.text();
        let data = raw ? JSON.parse(raw) : {};
        if (typeof data === 'string') data = JSON.parse(data);
        data = unwrap_response(data);
        if (!response.ok || data.status === 'error' || data.status === 'failed') throw new Error(get_error_message(data, `Login failed: ${response.status}`));
        if (data.otp_required === false || data.token) { await this.complete_token_login(data); return; }
        if (!data.challenge_token) throw new Error('The login server did not return a verification challenge. Please try again or contact support.');
        sessionStorage.setItem('pending_user_data', JSON.stringify(data.user || {}));
        sessionStorage.setItem('pending_username', this.credentials.email);
        sessionStorage.setItem('pending_challenge_token', data.challenge_token);
        sessionStorage.setItem('pending_login_password', this.credentials.password);
        this.set_success_message('Verification code sent. Check your email to continue.');
        this.$router.push('/one_time_pin');
      } catch (error) {
        this.set_error_message(error.message || 'Login failed. Please try again.');
      } finally {
        this.is_loading = false;
      }
    }
  }
};
